

export default {

   //tips获取样式（err或suc）
   tipsClass(type){
        var cla = [];
        switch (type) {
            case "error":
                cla.push("err");
                break;
            case "true":
                cla.push("suc");
                break;
            default:
                break;
        }
        return cla;
    },
    //获取样式
    inputClass(type){
        var cla = [];
        switch (type) {
            case "error":
                cla.push("error");
                break;
            case "true":
                cla.push("suc");
                break;
            case "select":
                cla.push("focus");
                break;
            default:
                break;
        }
        return cla;
    },
    //获取焦点后清除提示
    focusInput(direction,type){
        switch (type) {
            case "name":
                direction.selectInput.name='select';
                direction.tipsMsg.name='';
                break;
            case "email":
                direction.selectInput.email='select';
                direction.tipsMsg.email='';
                break;
            case "password":
                direction.selectInput.password='select';
                direction.tipsMsg.password='';
                break;
            case "rePassword":
                direction.selectInput.rePassword='select';
                direction.tipsMsg.rePassword='';
                break;
            case "code":
                direction.selectInput.code='select';
                direction.tipsMsg.code='';
                break;
            default:
                direction.selectInput = {
                    name: "normal",
                    email: "normal",
                    password: "normal",
                    rePassword: "normal",
                    code: "normal",
                    btn: "normal"
                };
                direction.tipsMsg = {
                    name: "",
                    email: "",
                    password: "",
                    rePassword: "",
                    code: "",
                    btn: "",
                };
                break;
        }
        direction.selectInput.btn='normal';
        direction.tipsMsg.btn='';
    },
    /* 检查格式 */
    testName(direction){
        direction.name = direction.name.trim();
        if (direction.name == "") {
            direction.selectInput.name = "error";
            direction.tipsMsg.name = direction.$t('language.login.exception.strEmpty');
        } else if (direction.name.length > 20) {
            direction.selectInput.name = "error";
            direction.tipsMsg.name = direction.$t('language.login.exception.nameToLong');
        } else {
            direction.selectInput.name = "normal";
            direction.tipsMsg.name = "";
        }
    },
    testEmail(direction){
        direction.email = direction.email.trim();
        var emailRegex = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
        if (direction.email == "") {
            direction.selectInput.email = "error";
            direction.tipsMsg.email = direction.$t('language.login.exception.strEmpty');
        } else if (!emailRegex.test(direction.email) || direction.email.length > 128) {
            direction.selectInput.email = "error";
            direction.tipsMsg.email = direction.$t('language.login.exception.emailError');
        } else {
            direction.selectInput.email = "normal";
            direction.tipsMsg.email = "";
        }
    },
    testPassword(direction){
        direction.password = direction.password.trim();
        if (direction.password == "") {
            direction.selectInput.password = "error";
            direction.tipsMsg.password = direction.$t('language.login.exception.strEmpty');
        } else if (direction.password.length < 8 || direction.password.length > 16) {
            direction.selectInput.password = "error";
            direction.tipsMsg.password = direction.$t('language.login.exception.pwdError');
        } else {
            direction.selectInput.password = "normal";
            direction.tipsMsg.password = "";
        }
    },
    testRePassword(direction){
        direction.rePassword = direction.rePassword.trim();
        if (direction.rePassword == "") {
            direction.selectInput.rePassword = "error";
            direction.tipsMsg.rePassword = direction.$t('language.login.exception.rePsdEmpty');
        } else if (direction.rePassword != direction.password) {
            direction.selectInput.rePassword = "error";
            direction.tipsMsg.rePassword = direction.$t('language.login.exception.rePwdError');
        } else {
            direction.selectInput.rePassword = "normal";
            direction.tipsMsg.rePassword = "";
        }
    },
    testCode(direction){
        direction.code = direction.code.trim();
        if (direction.code == "") {
            direction.selectInput.code = "error";
            direction.tipsMsg.code = direction.$t('language.login.exception.codeEmpty');
        } else if (direction.code.length != 4) {
            direction.selectInput.code = "error";
            direction.tipsMsg.code = direction.$t('language.login.exception.codeError');
        } else {
            direction.selectInput.code = "normal";
            direction.tipsMsg.code = "";
        }
    },
}



// WEBPACK FOOTER //
// ./src/js/workspace/login_popup.js